import styled from 'styled-components'
import MenuItem from '@material-ui/core/MenuItem'

export const DeleteMenuItem = styled(MenuItem)`
	color: ${props => props.theme.tag.red};
`

export default DeleteMenuItem
